import {
  SET_USER_IS_ADMIN,
  SET_ADMIN_DATA,
  SET_ADMIN_USERS,
  SET_ADMIN_TASKS,
  SET_ADMIN_SESSIONS,
  SET_ADMIN_STATS,
  SET_ADMIN_FEEDBACK,
  SET_ADMIN_CONVERSATIONS,
  SET_ADMIN_LOADING,
} from "../constants/admin";

const initialValue = {
  analytics: {},
  users: [],
  recentVisits: [],
  tasks: [],
  conversations: {},
  feedback: [],
  // Loading states for each data type
  loading: {
    users: false,
    tasks: false,
    sessions: false,
    stats: false,
    feedback: false,
    conversations: false,
  },
  // Track which data has been loaded
  loaded: {
    users: false,
    tasks: false,
    sessions: false,
    stats: false,
    feedback: false,
    conversations: false,
  },
};

export default (state = initialValue, action) => {
  switch (action.type) {
    case SET_USER_IS_ADMIN:
      return { ...state, isAdmin: action.isAdmin };

    case SET_ADMIN_DATA:
      // Full data update - mark everything as loaded
      return {
        ...state,
        ...action.data,
        loaded: {
          users: true,
          tasks: true,
          sessions: true,
          stats: true,
          feedback: true,
          conversations: true,
        },
        loading: {
          users: false,
          tasks: false,
          sessions: false,
          stats: false,
          feedback: false,
          conversations: false,
        },
      };

    case SET_ADMIN_USERS:
      return {
        ...state,
        users: action.users,
        loading: { ...state.loading, users: false },
        loaded: { ...state.loaded, users: true },
      };

    case SET_ADMIN_TASKS:
      return {
        ...state,
        tasks: action.tasks,
        loading: { ...state.loading, tasks: false },
        loaded: { ...state.loaded, tasks: true },
      };

    case SET_ADMIN_SESSIONS:
      return {
        ...state,
        recentVisits: action.recentVisits,
        loading: { ...state.loading, sessions: false },
        loaded: { ...state.loaded, sessions: true },
      };

    case SET_ADMIN_STATS:
      return {
        ...state,
        analytics: action.analytics,
        loading: { ...state.loading, stats: false },
        loaded: { ...state.loaded, stats: true },
      };

    case SET_ADMIN_FEEDBACK:
      return {
        ...state,
        feedback: action.feedback,
        loading: { ...state.loading, feedback: false },
        loaded: { ...state.loaded, feedback: true },
      };

    case SET_ADMIN_CONVERSATIONS:
      return {
        ...state,
        conversations: action.conversations,
        loading: { ...state.loading, conversations: false },
        loaded: { ...state.loaded, conversations: true },
      };

    case SET_ADMIN_LOADING:
      return {
        ...state,
        loading: { ...state.loading, [action.key]: action.isLoading },
      };

    default:
      return state;
  }
};
